@import '../../stylesheets/mixins/common'

$xs-spinner-size = 18px
$small-spinner-size = 22px
$large-spinner-size = 40px
$medium-fancy-spinner-size = 96px
$large-fancy-spinner-size = 250px

.spinner-wrapper
  display inline-block
  height $small-spinner-size
  width $small-spinner-size

  &.xs
    height $xs-spinner-size
    width $xs-spinner-size

  &.large
    height $large-spinner-size
    width $large-spinner-size

  &.medium-fancy
    height $medium-fancy-spinner-size
    width $medium-fancy-spinner-size

  &.large-fancy
    height $large-fancy-spinner-size
    width $large-fancy-spinner-size

.mp-spinner
  animation spin 0.7s infinite linear
  height 100%
  transform translateZ(0)
  width 100%

.mp-spinner-blue
  > svg-icon
    svg-icon-style-props('%s' % var(--blue1), size: 100%)

.mp-spinner-white
  > svg-icon
    svg-icon-style-props('%s' % $white, size: 100%)

.mp-spinner-inherit-color
  > svg-icon
    svg-icon-style-props(size: 100%)

.custom-spinner
  background-size contain
  height 100%
  width 100%

  &.luv
    background-image url('./hearts.gif')
  &.horse-run
    background-image url('./horse-run.gif')
  &.fancy
    height $large-spinner-size
    width $large-spinner-size
    &.medium-spinner
      height $medium-fancy-spinner-size
      width $medium-fancy-spinner-size
    &.large-spinner
      height $large-fancy-spinner-size
      width $large-fancy-spinner-size

/* TODO - this size needs to be adjusted for anyone using medium-spinners */
.medium-spinner
  height $large-spinner-size
  width $large-spinner-size

.large-spinner
  height $large-spinner-size
  width $large-spinner-size

@keyframes spin
  0%
    transform rotate(0deg)

  100%
    transform rotate(360deg)
